import React from "react";
import Icon from "./Icon";

function EmptyState({ searchQuery }) {
  if (searchQuery) {
    return (
      <div className="empty-state gd-empty-state">
        <Icon name="search" size={48} />
        <h4>No results for "{searchQuery}"</h4>
        <p>Try a different search term</p>
      </div>
    );
  }
  return (
    <div className="empty-state gd-empty-state">
      <Icon name="folderOpen" size={48} />
      <h4>This folder is empty</h4>
      <p>Upload files or create documents to get started</p>
    </div>
  );
}

export default EmptyState;
